import { render, staticRenderFns } from "./ClaimAssessmentForm.vue?vue&type=template&id=0f7573f6&"
import script from "./ClaimAssessmentForm.vue?vue&type=script&lang=ts&"
export * from "./ClaimAssessmentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports